import(/* webpackMode: "eager" */ "/Users/imacm1red/Documents/pione-group-v2/src/app/[lang]/not-found.tsx");
